import type React from 'react';
import { dayjs } from 'src/helper/date';

const AuthCopyright: React.FC = () => (
  <p className="ls-copyright">
    Copyright © {dayjs().format('YYYY')} Foresight. All rights reserved.
  </p>
);

export default AuthCopyright;
